module.exports = __webpack_public_path__ + "img/venn-diagram.39adef13.svg";